import {NewTabDqButtonLocations} from 'module/DqButton/type/DqButtonLocations'
import {Epic} from 'redux-observable'
import {filter, switchMap} from 'rxjs/operators'
import {dqButtonResponseAction} from 'module/DqButton/action/DqButtonsAction'
import axios from 'axios'

export const GenericDqButtonSinkEpic: Epic = (action$, state$) => action$.pipe(
	filter(dqButtonResponseAction.match),
	switchMap(({payload}) => {
		const location = payload.dqButton.location
		if (NewTabDqButtonLocations.includes(location)) {
			payload.result.forEach(link => {
				if (!link) return;
				const url = link + ''
				if (url.startsWith('../json/')) {
					axios.get(url).then(({data}) => data && window.open(data, '_blank'))
				} else {
					window.open(url, '_blank')
				}
			})
		}
		return []
	}),
)